import { getStoredConsent } from "./cookieConsent.helpers";

const GA_ID = "G-XXXXXXXXXX";
const META_PIXEL_ID = "123456789012345";

function loadAnalyticsIfAllowed() {
  const consent = getStoredConsent();

  if (!consent?.analytics) return;
  if (window.__gaLoaded) return;

  window.__gaLoaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }

    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID);
  };
}

function loadMetaPixelIfAllowed() {
  const consent = getStoredConsent();

  if (!consent?.marketing) return;
  if (window.__metaPixelLoaded) return;

  window.__metaPixelLoaded = true;

  const loadPixel = (f, b, e, v, n, t, s) => {
    if (f.fbq) return;

    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };

    if (!f._fbq) f._fbq = n;

    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];

    t = b.createElement(e);
    t.async = true;
    t.src = v;

    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  };

  loadPixel(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );

  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

export const loadAllowedTrackers = () => {
  loadAnalyticsIfAllowed();
  loadMetaPixelIfAllowed();
};
